import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import ButtonRounded from "../../../../components/ButtonRounded";
import ToggleButton from "../../../../components/ToggleButton";
import { makeStyles, createStyles, Theme, withStyles } from "@material-ui/core/styles";
import getConfirmState from "../../../../api/sustainability/reports/getConfirmState";
import getDownloadReport, {
  Tfiletype,
} from "../../../../api/sustainability/reports/getDownloadReport";
import ModalInfo from "../../../../components/modal/ModalInfo";
import ModalConfirmDelivery from "./ModalConfirmDelivery";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import Select from "@material-ui/core/Select";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import MenuItem from "@material-ui/core/MenuItem";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import clsx from "clsx";
import {getRoadUseDraftReport} from "../../../../api/sustainability/DraftReports/roadUse/getDraftReport";
import {useHistory} from "react-router-dom";
import parseAndFormat from "../../../../components/texts/parseAndFormat";
import { brandColors } from "../../../../theme";

import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const ExpansionPanel = withStyles((theme: Theme) => ({
  root: {
    marginBottom: theme.spacing(2),
    "&.Mui-expanded:last-child": {
      marginBottom: theme.spacing(2),
    },
    "&.MuiExpansionPanel-root:before": { backgroundColor: "transparent" },
  },
}))(MuiExpansionPanel);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& .MuiOutlinedInput-input": {
        padding: theme.spacing(1),
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
        fontSize: "14px",
      },
    },
    titleSection: {
      marginBottom: theme.spacing(3),
    },
    h2: {
      [theme.breakpoints.down("md")]: {
        fontSize: "32px",
      },
    },
    select: {
      width: "150px",
      [theme.breakpoints.down("md")]: {
        width: "100px",
      },
    },
    sectionDownloads: {
      marginBottom: theme.spacing(2),
    },
    section: {
      marginBottom: theme.spacing(3),
      "&:last-child": {
        marginBottom: 0,
      },
    },
    card: {
      height: "100%",
    },
    cardContent: {
      padding: theme.spacing(3.75),
      paddingTop: theme.spacing(4),
      "&:last-child": {
        paddingBottom: theme.spacing(3.75),
      },
    },
    topSpacing: {
      marginTop: theme.spacing(2),
    },
    cardTitle: {
      marginBottom: theme.spacing(0.5),
    },
    cardSubTitle: {
      fontSize: theme.typography.h5.fontSize,
      marginBottom: theme.spacing(2.5),
      marginTop: theme.spacing(2),
    },
    table: {
      "& .MuiTableBody-root .MuiTableRow-root:nth-child(odd)": {
        backgroundColor: theme.palette.grey[50],
      },
      "& .MuiTableCell-root": {
        border: "none",
        paddingTop: 0,
        paddingBottom: 0,
        height: theme.spacing(4),
      },
      "& .MuiTableCell-head": {
        color: "inherit",
        fontSize: "12px",
        fontWeight: 700,
        backgroundColor: theme.palette.grey[300],
      },
    },
    tableContainer: {
      maxHeight: "450px",
      overflowY: "auto", // "scroll",
      "& .MuiOutlinedInput-input": {
        ...theme.typography.caption,
        fontWeight: 500,
        color: theme.palette.primary.main,
      },
    },
    btnDownloads: {
      height: "100%",
    },
    circularProgress: {
      margin: "80px",
      width: "48px",
      height: "48px",
    },
  })
);

interface Props {
  activePeriod: any;
  isSimulation: boolean;
  isJoint: boolean;
  toggleSimulation: any;
  data: any;
  getPageData: any;
  isFetching: boolean;
  taxPeriods: any[];
  selectedYear: number;
  setSelectedYear: any;
}

const ReportsView: React.FC<Props> = ({
  activePeriod,
  isSimulation,
  isJoint,
  toggleSimulation,
  data,
  getPageData,
  isFetching,
  taxPeriods,
  selectedYear,
  setSelectedYear,
}) => {
  const [expanded, setExpanded] = useState<string[]>([]);

  const handleAccordionChange = (panel: string) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean
  ) => {
    setExpanded(isExpanded
      ? [...expanded, panel]
      : expanded.filter(item => item !== panel)
    );
  };
  const history = useHistory();
  const [report, setReport] = useState(null);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [selectedPart, setSelectedPart] = useState<any>(activePeriod.name);
  const [
    showConfirmDeliveryModal,
    setShowConfirmDeliveryModal,
  ] = useState<boolean>(false);

  const openErrorModal = (msg: string) => {
    setErrorMessage(msg);
    setShowErrorModal(true);
  };
  const closeErrorModal = () => {
    setErrorMessage("");
    setShowErrorModal(false);
  };

  const openConfirmDeliveryModal = () => {
    setShowConfirmDeliveryModal(true);
  };

  const closeConfirmDeliveryModal = () => {
    setShowConfirmDeliveryModal(false);
  };

  const classes = useStyles();

  const handleDownload = async (type: Tfiletype) => {
    const response = await getDownloadReport({
      type,
      mandate_type: "roaduse",
      taxYear: selectedYear,
    });
    if (response === null) {
      openErrorModal(
        "Failed to download file: Possible errors: no file for selected year or other errors."
      );
    }

    if (response !== null) {
      // emulate file download by clicking on an <a /> link
      const url = window.URL.createObjectURL(response);
      const fileName =
          type === "draft_report_excel"
              ? "sustainability-draft-report"
              : type.indexOf("sub") > -1
                  ? "sustainability-subreport"
                  : "sustainability-report";
      const fileExt = type.indexOf("excel") > -1 ? "xlsx" : "json";

      const a = document.createElement("a");
      a.href = url;
      a.download = `${fileName}-roaduse-${selectedYear}.${fileExt}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
  };

  const handleConfirmationStatus = async () => {
    const res = await getConfirmState({ taxYear: selectedYear });
    if (res === null) {
      openErrorModal(
        "Failed to confirm delivery. Possible errors: correct reporting year is not selected or other errors."
      );
    } else {
      openErrorModal(
          "Delivery Confirmed."
      );
      getPageData(selectedYear);
    }
  };

  const getCellColor = (cellValue: any) => {
    if (!cellValue) {
        return "#a1aeb7";
    } else if (cellValue == "N/A" || cellValue == 0 || cellValue == "") {
        return "#a1aeb7";
    } else {
        return "#424b5a";
    }
  };

  // on init
  useEffect(() => {
    setSelectedYear(activePeriod.year);
  }, []);

  useEffect(() => {
    getPageData(selectedYear);
  }, [selectedYear]);

  // report overview
  const goToReportOverview = () => {
    history.push(`/sustainability/reportoverview/`);
  };

  useEffect(() => {
    const fetchReport = async () => {
      const data = await getRoadUseDraftReport();
      if (data) {
        setReport(data);
      } else {
      }
    };

    fetchReport();
  }, []);

  // @ts-ignore
  if (!report || !report.data || !report.data.mandate_fulfillment_status || !report.data.mandate_fulfillment_status.fulfillment_status) {
    return <p></p>;
  }

  // @ts-ignore
  const mandateFulfillmentStatus = report.data.mandate_fulfillment_status;
  // @ts-ignore
  const volumeSummary = report.data.volume_summary;
  // @ts-ignore
  const allocatedBatches = report.data.allocated_batches;
  // @ts-ignore
  const allocationDetails = report.data.allocation_details;
  // @ts-ignore
  const surplusOverview = report.data.surplus_overview;

  const bgColorGreen = brandColors.success.bg;
  const bgColorYellow = brandColors.primary.light;
  const bgColorRed = brandColors.secondary.bg;
  const bgColorGray = "#C2D1D9";

  let colorDetailsAdvanced = bgColorGray;
  if (allocationDetails.advanced_mandate_status === "SUB-MANDATE OK") {
    colorDetailsAdvanced = bgColorGreen;
  } else {
    colorDetailsAdvanced = bgColorRed;
  }

  let colorDetailsGeneral = bgColorGray;
  if (allocationDetails.general_mandate_status === "MANDATE OK") {
    colorDetailsGeneral = bgColorGreen;
  } else {
    colorDetailsGeneral = bgColorRed;
  }

  let colorDetailsLockedSurplus = bgColorGray;
  if (allocationDetails.locked_surplus_status === "LOCKED SURPLUS OK") {
    colorDetailsLockedSurplus = bgColorGreen;
  } else {
    colorDetailsLockedSurplus = bgColorRed;
  }

  let colorDetailsAvailableSurplus = bgColorGray;
  if (allocationDetails.mandate_surplus_available_status === "AVAILABLE SURPLUS OK") {
    colorDetailsAvailableSurplus = bgColorGreen;
  } else {
    colorDetailsAvailableSurplus = bgColorRed;
  }

  let colorDetailsVolume = bgColorGray;
  if (allocationDetails.volume_check_status === "VOLUME MATCH") {
    colorDetailsVolume = bgColorGreen;
  } else {
    colorDetailsVolume = bgColorRed;
  }

  let statusColorAdvanced = bgColorGreen;
  if (mandateFulfillmentStatus.fulfillment_status.advanced_mandate === "Not fulfilled") {
    statusColorAdvanced = bgColorRed;
  } else if (mandateFulfillmentStatus.fulfillment_status.advanced_mandate === "Over-allocated") {
    statusColorAdvanced = bgColorYellow;
  }

  let statusColorGeneral = bgColorGreen;
  if (mandateFulfillmentStatus.fulfillment_status.general_mandate === "Not fulfilled") {
    statusColorGeneral = bgColorRed;
  } else if (mandateFulfillmentStatus.fulfillment_status.general_mandate === "Over-allocated") {
    statusColorGeneral = bgColorYellow;
  }

  let statusColorReqByCust = bgColorGreen;
  if (mandateFulfillmentStatus.fulfillment_status.req_by_cust_mandate_LE === "Not fulfilled") {
    statusColorReqByCust = bgColorRed;
  } else if (mandateFulfillmentStatus.fulfillment_status.req_by_cust_mandate_LE === "Over-allocated") {
    statusColorReqByCust = bgColorYellow;
  }

  let statusColorOutJoint = bgColorGreen;
  if (mandateFulfillmentStatus.fulfillment_status.out_joint_fulfillment === "Not fulfilled") {
    statusColorOutJoint = bgColorRed;
  } else if (mandateFulfillmentStatus.fulfillment_status.out_joint_fulfillment === "Over-allocated") {
    statusColorOutJoint = bgColorYellow;
  } else if (mandateFulfillmentStatus.fulfillment_status.out_joint_fulfillment === "Not relevant") {
    statusColorOutJoint = "#f0f0f0";
  }

  let statusColorAfterFulfill = bgColorGreen;
  if (mandateFulfillmentStatus.fulfillment_status.after_mandate_fulfill_LE === "Not fulfilled") {
    statusColorAfterFulfill = bgColorRed;
  } else if (mandateFulfillmentStatus.fulfillment_status.after_mandate_fulfill_LE === "Over-allocated") {
    statusColorAfterFulfill = bgColorYellow;
  }
  // @ts-ignore
  return (
    <div className={classes.root}>
      <Grid
        container
        justify="space-between"
        alignItems="center"
        className={classes.titleSection}
      >
        <Grid item>
          <Typography variant="h2" className={classes.h2}>
            Draft report: <span style={{ color: brandColors.primary.main }}>Road use</span>
          </Typography>
        </Grid>
        <Grid item>
          <Grid container spacing={2} alignItems="center">
            {!isFetching &&
              data &&
              data.tax_year_seq &&
              data.tax_year_seq.length > 1 && (
                <Grid item>
                  <Select
                    fullWidth
                    className={classes.select}
                    input={<OutlinedInput labelWidth={0} />}
                    value={selectedPart}
                    onChange={e => setSelectedPart(e.target.value)}
                  >
                    {data.tax_year_seq.map(
                      (partName: string, index: number) => (
                        <MenuItem value={partName}>
                          {"Part " +
                            partName
                              .replace(selectedYear + "", "")
                              .match(/\d+/)}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </Grid>
              )}

            <Grid item>
              <Select
                fullWidth
                className={classes.select}
                input={<OutlinedInput labelWidth={0} />}
                value={selectedYear}
                onChange={e => setSelectedYear(e.target.value)}
              >
                {taxPeriods
                  ? taxPeriods.map((year: any, index: number) => (
                      <MenuItem
                        value={Object.keys(year)[0]}
                        key={
                          "Sus.View_Reports_Year_" +
                          Object.keys(year)[0] +
                          "-" +
                          index
                        }
                      >
                        {Object.keys(year)[0]}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </Grid>

            <Grid item>
              <ToggleButton
                labels={["Reporting", "Simulation"]}
                defaultLabelIndex={isSimulation ? 1 : 0}
                size="small"
                bgWhite
                handleChange={toggleSimulation}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2} className={classes.sectionDownloads}>
        <Grid item xs={7}>
          <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h5" className={classes.cardTitle}>
                    Allocation Mode: <span style={{ color: brandColors.primary.main }}>{isSimulation ? "Simulation" : "Reporting"}</span>
                  </Typography>
                  <Typography variant="h5" className={classes.cardTitle}>
                    Period: <span style={{ color: brandColors.primary.main }}>{activePeriod.year}</span>
                  </Typography>
                  <Typography variant="h5" className={classes.cardTitle}>
                    Fulfillment type: <span style={{ color: brandColors.primary.main }}>{mandateFulfillmentStatus.joint_fulfillment.is_joint ? "Joint" : "Own"}</span>
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={5}>
          <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
              <Typography variant="h5" className={classes.cardTitle}>
                <p>Report File and Actions</p>
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={4} style={{padding: "7px"}}>
                  <ButtonRounded
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={() => handleDownload("draft_report_excel")}
                  >
                    Draft Report (Excel)
                  </ButtonRounded>
                </Grid>
                <Grid item xs={4} style={{padding: "7px"}}>
                  <ButtonRounded
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={() => handleDownload("report_excel")}
                  >
                    Tilde report file
                  </ButtonRounded>
                </Grid>
                <Grid item xs={4} style={{padding: "7px"}}>
                  <ButtonRounded
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={goToReportOverview}
                      disabled={false}
                  >
                    Report overview
                  </ButtonRounded>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      {isFetching ? (
        <Box
          flex={1}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress className={classes.circularProgress} />
        </Box>
      ) : (
        <div>
          <ExpansionPanel expanded={expanded.includes("mandate")} onChange={handleAccordionChange("mandate")}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h5" className={classes.cardTitle}>
                Mandate fulfillment status
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Table className={classes.table}>
                <TableHead className="MuiTableCell-head">
                  <TableRow>
                    <TableCell>Fulfillment status</TableCell>
                    <TableCell>Requirement</TableCell>
                    <TableCell>Required Volume</TableCell>
                    <TableCell>Joint fulfillment IN</TableCell>
                    <TableCell>Flexibility surplus IN</TableCell>
                    <TableCell>Allocated(LE)</TableCell>
                    <TableCell>Allocated(L15)</TableCell>
                    <TableCell>Remaining volume</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="MuiTableBody-root">
                  <TableRow>
                    <TableCell style={{backgroundColor: statusColorAdvanced}}>{mandateFulfillmentStatus.fulfillment_status.advanced_mandate}</TableCell>
                    <TableCell style={{backgroundColor: statusColorAdvanced}}>Advanced sub-mandate ({mandateFulfillmentStatus.requirement.advanced_mandate}%)</TableCell>
                    <TableCell style={{backgroundColor: statusColorAdvanced}}>{parseAndFormat(mandateFulfillmentStatus.req_vol.advanced_mandate, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorAdvanced}}>{
                      mandateFulfillmentStatus.joint_fulfillment.is_joint === false ? "N/A" : parseAndFormat(mandateFulfillmentStatus.joint_fulfillment.advanced_mandate, 2)
                    }</TableCell>
                    <TableCell style={{backgroundColor: statusColorAdvanced}}>{parseAndFormat(mandateFulfillmentStatus.surplus.advanced_mandate, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorAdvanced}}>{parseAndFormat(mandateFulfillmentStatus.allocated_LE.advanced_mandate_LE, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorAdvanced}}>{parseAndFormat(mandateFulfillmentStatus.allocated_15.advanced_mandate_15, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorAdvanced}}>{parseAndFormat(mandateFulfillmentStatus.remaining_volume.advanced_mandate, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{backgroundColor: statusColorGeneral}}>{mandateFulfillmentStatus.fulfillment_status.general_mandate}</TableCell>
                    <TableCell style={{backgroundColor: statusColorGeneral}}>General mandate ({mandateFulfillmentStatus.requirement.general_mandate}%)</TableCell>
                    <TableCell style={{backgroundColor: statusColorGeneral}}>{parseAndFormat(mandateFulfillmentStatus.req_vol.general_mandate, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorGeneral}}>{
                      mandateFulfillmentStatus.joint_fulfillment.is_joint === false ? "N/A" : parseAndFormat(mandateFulfillmentStatus.joint_fulfillment.general_mandate, 2)
                    }</TableCell>
                    <TableCell style={{backgroundColor: statusColorGeneral}}>{parseAndFormat(mandateFulfillmentStatus.surplus.general_mandate, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorGeneral}}>{parseAndFormat(mandateFulfillmentStatus.allocated_LE.general_mandate_LE, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorGeneral}}>{parseAndFormat(mandateFulfillmentStatus.allocated_15.general_mandate_15, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorGeneral}}>{parseAndFormat(mandateFulfillmentStatus.remaining_volume.general_mandate, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{backgroundColor: statusColorReqByCust}}>{mandateFulfillmentStatus.fulfillment_status.req_by_cust_mandate_LE}</TableCell>
                    <TableCell style={{backgroundColor: statusColorReqByCust}}>Above the mandate (required by customers)</TableCell>
                    <TableCell style={{backgroundColor: statusColorReqByCust}}>{parseAndFormat(mandateFulfillmentStatus.req_vol.req_by_cust_mandate, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorReqByCust}}>{mandateFulfillmentStatus.joint_fulfillment.req_by_cust_mandate}</TableCell>
                    <TableCell style={{backgroundColor: statusColorReqByCust}}>{parseAndFormat(mandateFulfillmentStatus.surplus.req_by_cust_mandate, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorReqByCust}}>{parseAndFormat(mandateFulfillmentStatus.allocated_LE.req_by_cust_mandate_LE, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorReqByCust}}>{parseAndFormat(mandateFulfillmentStatus.allocated_15.req_by_cust_mandate_15, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorReqByCust}}>{parseAndFormat(mandateFulfillmentStatus.remaining_volume.req_by_cust_mandate, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{backgroundColor: statusColorOutJoint}}>{mandateFulfillmentStatus.fulfillment_status.out_joint_fulfillment}</TableCell>
                    <TableCell style={{backgroundColor: statusColorOutJoint}}>Joint Fulfillment OUT</TableCell>
                    <TableCell style={{backgroundColor: statusColorOutJoint}}>{parseAndFormat(mandateFulfillmentStatus.req_vol.out_joint_fulfillment, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorOutJoint}}>{mandateFulfillmentStatus.joint_fulfillment.out_joint_fulfillment}</TableCell>
                    <TableCell style={{backgroundColor: statusColorOutJoint}}>{parseAndFormat(mandateFulfillmentStatus.surplus.out_joint_fulfillment, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorOutJoint}}>{parseAndFormat(mandateFulfillmentStatus.allocated_LE.out_joint_fulfillment, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorOutJoint}}>{parseAndFormat(mandateFulfillmentStatus.allocated_15.out_joint_fulfillment, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorOutJoint}}>{parseAndFormat(mandateFulfillmentStatus.remaining_volume.out_joint_fulfillment, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{backgroundColor: statusColorAfterFulfill}}>{mandateFulfillmentStatus.fulfillment_status.after_mandate_fulfill_LE}</TableCell>
                    <TableCell style={{backgroundColor: statusColorAfterFulfill}}>Above the mandate (after mandate fulfillment)</TableCell>
                    <TableCell style={{backgroundColor: statusColorAfterFulfill}}>{parseAndFormat(mandateFulfillmentStatus.req_vol.after_mandate_fulfill, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorAfterFulfill}}>{mandateFulfillmentStatus.joint_fulfillment.after_mandate_fulfill}</TableCell>
                    <TableCell style={{backgroundColor: statusColorAfterFulfill}}>{parseAndFormat(mandateFulfillmentStatus.surplus.after_mandate_fulfill, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorAfterFulfill}}>{parseAndFormat(mandateFulfillmentStatus.allocated_LE.after_mandate_fulfill_LE, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorAfterFulfill}}>{parseAndFormat(mandateFulfillmentStatus.allocated_15.after_mandate_fulfill_15, 2)}</TableCell>
                    <TableCell style={{backgroundColor: statusColorAfterFulfill}}>{parseAndFormat(mandateFulfillmentStatus.remaining_volume.after_mandate_fulfill, 2)}</TableCell>
                  </TableRow>
                </TableBody>

              </Table>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          <ExpansionPanel expanded={expanded.includes("batches")} onChange={handleAccordionChange("batches")}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h5" className={classes.cardTitle}>
                Sustainability batches
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Table className={classes.table}>
                <TableHead className="MuiTableCell-head">
                  <TableRow>
                    <TableCell style={{ width: "5%" }}>Batch#</TableCell>
                    <TableCell style={{ width: "10%" }}>Biofuel Type</TableCell>
                    <TableCell style={{ width: "10%" }}>Volume(L)</TableCell>
                    <TableCell style={{ width: "15%" }}>Raw material</TableCell>
                    <TableCell style={{ width: "5%" }}>Advanced</TableCell>
                    <TableCell style={{ width: "10%" }}>Origin</TableCell>
                    <TableCell style={{ width: "5%" }}>Ghg red.</TableCell>
                    <TableCell style={{ width: "10%" }}>Storage terminal</TableCell>
                    <TableCell style={{ width: "15%" }}>Certification scheme</TableCell>
                    <TableCell style={{ width: "10%" }}>Certification ID</TableCell>
                    <TableCell style={{ width: "5%" }}>Etot</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="MuiTableBody-root">
                  {
                    allocatedBatches.map((biotemplate: any, index: number) => (
                        <TableRow key={index}>
                          <TableCell style={{ width: "5%" }}>{index + 1}</TableCell>
                          <TableCell style={{ width: "10%" }}>{biotemplate.biofuel_type}</TableCell>
                          <TableCell style={{ width: "10%" }}>{parseAndFormat(biotemplate.volume, 2)}</TableCell>
                          <TableCell style={{ width: "15%" }}>{biotemplate.raw_material}</TableCell>
                          <TableCell style={{ width: "5%" }}>{biotemplate.double_counted_norway}</TableCell>
                          <TableCell style={{ width: "10%" }}>{biotemplate.raw_material_origin}</TableCell>
                          <TableCell style={{ width: "5%" }}>{parseAndFormat(biotemplate.reduction_in_climate_emission, 2)}</TableCell>
                          <TableCell style={{ width: "10%" }}>{biotemplate.storage_terminal}</TableCell>
                          <TableCell style={{ width: "15%" }}>{biotemplate.documentation_emission_of_climate}</TableCell>
                          <TableCell style={{ width: "10%" }}>{biotemplate.certification_id}</TableCell>
                          <TableCell style={{ width: "5%" }}>{parseAndFormat(biotemplate.etot, 2)}</TableCell>
                        </TableRow>
                    ))
                  }
                </TableBody>

              </Table>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          <ExpansionPanel expanded={expanded.includes("volume")} onChange={handleAccordionChange("volume")}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h5" className={classes.cardTitle}>
                Volume summary
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
            <Table className={classes.table}>
                <TableHead className="MuiTableCell-head">
                  <TableRow>
                    <TableCell style={{width: "20%"}}>GASOLINE products</TableCell>
                    <TableCell style={{width: "15%"}}>Sold volume</TableCell>
                    <TableCell style={{width: "15%"}}>Allocated volume</TableCell>
                    <TableCell style={{width: "20%"}}>Diesel products</TableCell>
                    <TableCell style={{width: "15%"}}>Sold volumes</TableCell>
                    <TableCell style={{width: "15%"}}>Allocated volumes</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="MuiTableBody-root">
                  <TableRow>
                    <TableCell>Gasoline</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.sold.gasoline, 2)}</TableCell>
                    <TableCell></TableCell>
                    <TableCell>Diesel</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.sold.diesel, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{borderBottom: "1px solid black"}}>Bio components</TableCell>
                    <TableCell style={{borderBottom: "1px solid black"}}>{parseAndFormat(volumeSummary.sold.biocomponent_in_gasoline, 2)}</TableCell>
                    <TableCell style={{borderBottom: "1px solid black"}}>{parseAndFormat(volumeSummary.allocated.biocomponent_in_gasoline, 2)}</TableCell>
                    <TableCell style={{borderBottom: "1px solid black"}}>Bio components</TableCell>
                    <TableCell style={{borderBottom: "1px solid black"}}>{parseAndFormat(volumeSummary.sold.biocomponent_in_diesel, 2)}</TableCell>
                    <TableCell style={{borderBottom: "1px solid black"}}>{parseAndFormat(volumeSummary.allocated.biocomponent_in_diesel, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Etanol</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.sold.etanol, 2)}</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.allocated.etanol, 2)}</TableCell>
                    <TableCell>Fame</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.sold.fame, 2)}</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.allocated.fame, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Etanol (advanced)</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.sold.etanol_advanced, 2)}</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.allocated.etanol_advanced, 2)}</TableCell>
                    <TableCell>Fame (advanced)</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.sold.fame_advanced, 2)}</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.allocated.fame_advanced, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Nafta</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.sold.nafta, 2)}</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.allocated.nafta, 2)}</TableCell>
                    <TableCell>HVO/HRO</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.sold.hvo_hro, 2)}</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.allocated.hvo_hro, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Nafta (advanced)</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.sold.nafta_advanced, 2)}</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.allocated.nafta_advanced, 2)}</TableCell>
                    <TableCell>HVO/HRO (advanced)</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.sold.hvo_hro_advanced, 2)}</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.allocated.hvo_hro_advanced, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Biogasoline</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.sold.biogasoline, 2)}</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.allocated.biogasoline, 2)}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Biogasoline (advanced)</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.sold.biogasoline_advanced, 2)}</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.allocated.biogasoline_advanced, 2)}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
                <TableHead>
                  <TableRow>
                    <TableCell>Total gasoline volume</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.sold.total_gasoline, 2)}</TableCell>
                    <TableCell></TableCell>
                    <TableCell>Total diesel volume</TableCell>
                    <TableCell>{parseAndFormat(volumeSummary.sold.total_diesel, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          <ExpansionPanel expanded={expanded.includes("allocation")} onChange={handleAccordionChange("allocation")}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h5" className={classes.cardTitle}>
                Allocation details
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{ display: "block" }}>
              <Table className={classes.table}>
                <TableHead className="MuiTableCell-head">
                  <TableRow>
                    <TableCell style={{ width: "40%", backgroundColor: colorDetailsAdvanced }}>Advanced sub-mandate</TableCell>
                    <TableCell style={{ width: "20%", backgroundColor: colorDetailsAdvanced }}>{allocationDetails.advanced_mandate_status}</TableCell>
                    <TableCell style={{ width: "20%", backgroundColor: colorDetailsAdvanced }}></TableCell>
                    <TableCell style={{ width: "20%", backgroundColor: colorDetailsAdvanced }}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="MuiTableBody-root">
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.advanced_mandate_requirement)}}>Calculated mandate requirement</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.advanced_mandate_requirement)}}>{parseAndFormat(allocationDetails.advanced_mandate_requirement, 2)}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.advanced_in_joint_adv)}}>Joint fulfillment IN advanced biofuel</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.advanced_in_joint_adv)}}>{parseAndFormat(allocationDetails.advanced_in_joint_adv, 2)}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.advanced_surplus)}}>Volume flexibility IN from off-road mandate</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.advanced_surplus)}}>{parseAndFormat(allocationDetails.advanced_surplus, 2)}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.advanced_allocation_bio_adv_gasoline)}}>Allocation advanced biofuel in gasoline</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.advanced_allocation_bio_adv_gasoline)}}>{parseAndFormat(allocationDetails.advanced_allocation_bio_adv_gasoline, 2)}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.advanced_allocation_bio_adv_diesel)}}>Allocation advanced biofuel in diesel</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.advanced_allocation_bio_adv_diesel)}}>{parseAndFormat(allocationDetails.advanced_allocation_bio_adv_diesel, 2)}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
                <TableHead>
                  <TableRow>
                    <TableCell>Remaining volume advanced sub-mandate</TableCell>
                    <TableCell>{parseAndFormat(allocationDetails.advanced_remaining, 2)}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
              </Table>
              <Table className={`${classes.table} ${classes.topSpacing}`}>
                <TableHead className="MuiTableCell-head">
                  <TableRow>
                    <TableCell style={{ width: "40%", backgroundColor: colorDetailsGeneral }}>General mandate</TableCell>
                    <TableCell style={{ width: "20%", backgroundColor: colorDetailsGeneral }}>{allocationDetails.general_mandate_status}</TableCell>
                    <TableCell style={{ width: "20%", backgroundColor: colorDetailsGeneral }}></TableCell>
                    <TableCell style={{ width: "20%", backgroundColor: colorDetailsGeneral }}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="MuiTableBody-root">
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.general_mandate_requirement)}}>Calculated mandate requirement</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_mandate_requirement)}}>{parseAndFormat(allocationDetails.general_mandate_requirement, 2)}</TableCell>
                    <TableCell> = </TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_mandate_requirement)}}>{parseAndFormat(allocationDetails.general_mandate_requirement, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.general_in_joint_adv)}}>Joint fulfillment IN advanced biofuel</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_in_joint_adv)}}>{parseAndFormat(allocationDetails.general_in_joint_adv, 2)}</TableCell>
                    <TableCell> = </TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_in_joint_adv)}}>{parseAndFormat(allocationDetails.general_in_joint_adv, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.general_in_joint_conventional)}}>Joint fulfillment IN conventional biofuel</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_in_joint_conventional)}}>{parseAndFormat(allocationDetails.general_in_joint_conventional, 2)}</TableCell>
                    <TableCell> = </TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_in_joint_conventional)}}>{parseAndFormat(allocationDetails.general_in_joint_conventional, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.general_surplus)}}>Volume flexibility IN from off-road mandate</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_surplus)}}>{parseAndFormat(allocationDetails.general_surplus, 2)}</TableCell>
                    <TableCell> = </TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_surplus)}}>{parseAndFormat(allocationDetails.general_surplus, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.general_allocated_adv)}}>Allocated in advanced sub-mandate</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_allocated_adv)}}>{parseAndFormat(allocationDetails.general_allocated_adv, 2)}</TableCell>
                    <TableCell> = </TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_allocated_adv)}}>{parseAndFormat(allocationDetails.general_allocated_adv, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.general_allocation_bio_adv_gasoline)}}>Allocation advanced biofuel in gasoline</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_allocation_bio_adv_gasoline)}}>{parseAndFormat(allocationDetails.general_allocation_bio_adv_gasoline, 2)}</TableCell>
                    <TableCell> = </TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_allocation_bio_adv_gasoline)}}>{parseAndFormat(allocationDetails.general_allocation_bio_adv_gasoline, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.general_allocation_bio_adv_diesel)}}>Allocation advanced biofuel in diesel</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_allocation_bio_adv_diesel)}}>{parseAndFormat(allocationDetails.general_allocation_bio_adv_diesel, 2)}</TableCell>
                    <TableCell> = </TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_allocation_bio_adv_diesel)}}>{parseAndFormat(allocationDetails.general_allocation_bio_adv_diesel_le, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.general_allocation_bio_conventional_gasoline)}}>Allocation conventional biofuel in gasoline</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_allocation_bio_conventional_gasoline)}}>{parseAndFormat(allocationDetails.general_allocation_bio_conventional_gasoline, 2)}</TableCell>
                    <TableCell> = </TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_allocation_bio_conventional_gasoline)}}>{parseAndFormat(allocationDetails.general_allocation_bio_conventional_gasoline, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.general_allocation_bio_conventional_diesel)}}>Allocation conventional biofuel in diesel</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_allocation_bio_conventional_diesel)}}>{parseAndFormat(allocationDetails.general_allocation_bio_conventional_diesel, 2)}</TableCell>
                    <TableCell> = </TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.general_allocation_bio_conventional_diesel)}}>{parseAndFormat(allocationDetails.general_allocation_bio_conventional_diesel, 2)}</TableCell>
                  </TableRow>
                </TableBody>
                <TableHead>
                  <TableRow>
                    <TableCell>Remaining volume general mandate</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell>{parseAndFormat(allocationDetails.general_remaining, 2)}</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
              <Table className={`${classes.table} ${classes.topSpacing}`}>
                <TableHead className="MuiTableCell-head">
                  <TableRow>
                    <TableCell style={{ width: "40%", backgroundColor: colorDetailsLockedSurplus }}>Mandate Surplus LOCKED</TableCell>
                    <TableCell style={{ width: "40%", backgroundColor: colorDetailsLockedSurplus }}>{allocationDetails.locked_surplus_status}</TableCell>
                    <TableCell style={{ width: "20%", backgroundColor: colorDetailsLockedSurplus }}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="MuiTableBody-root">
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.total_locked_surplus)}}>Total volume locked surplus</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.total_locked_surplus)}}>{parseAndFormat(allocationDetails.total_locked_surplus, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_adv_gasoline_customer_req)}}>Advanced biofuel in gasoline required by customers</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_adv_gasoline_customer_req)}}>{parseAndFormat(allocationDetails.biofuel_adv_gasoline_customer_req, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_adv_diesel_customer_req)}}>Advanced biofuel in diesel required by customers</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_adv_diesel_customer_req)}}>{parseAndFormat(allocationDetails.biofuel_adv_diesel_customer_req, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_conventional_gasoline_customer_req)}}>Conventional biofuel in gasoline required by customers</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_conventional_gasoline_customer_req)}}>{parseAndFormat(allocationDetails.biofuel_conventional_gasoline_customer_req, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_conventional_diesel_customer_req)}}>Conventional biofuel in diesel required by customers</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_conventional_diesel_customer_req)}}>{parseAndFormat(allocationDetails.biofuel_conventional_diesel_customer_req, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.out_joint_adv_locked)}}>Joint fulfillment OUT advanced biofuel</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.out_joint_adv_locked)}}>{parseAndFormat(allocationDetails.out_joint_adv_locked, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.out_joint_conventional_locked)}}>Joint fulfillment OUT conventional biofuel</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.out_joint_conventional_locked)}}>{parseAndFormat(allocationDetails.out_joint_conventional_locked, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
                <TableHead>
                  <TableRow>
                    <TableCell>Remaining volume mandate surplus LOCKED</TableCell>
                    <TableCell>{parseAndFormat(allocationDetails.remaining_locked_surplus, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
              </Table>
              <Table className={`${classes.table} ${classes.topSpacing}`}>
                <TableHead className="MuiTableCell-head">
                  <TableRow>
                    <TableCell style={{ width: "40%", backgroundColor: colorDetailsAvailableSurplus }}>Mandate surplus AVAILABLE</TableCell>
                    <TableCell style={{ width: "40%", backgroundColor: colorDetailsAvailableSurplus }}>{allocationDetails.mandate_surplus_available_status}</TableCell>
                    <TableCell style={{ width: "20%", backgroundColor: colorDetailsAvailableSurplus }}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="MuiTableBody-root">
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.total_available_surplus)}}>Total volume available surplus</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.total_available_surplus)}}>{parseAndFormat(allocationDetails.total_available_surplus, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_adv_gasoline_available)}}>Advanced biofuel in gasoline</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_adv_gasoline_available)}}>{parseAndFormat(allocationDetails.biofuel_adv_gasoline_available, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_adv_diesel_available)}}>Advanced biofuel in diesel</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_adv_diesel_available)}}>{parseAndFormat(allocationDetails.biofuel_adv_diesel_available, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_conventional_gasoline_available)}}>Conventional biofuel in gasoline</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_conventional_gasoline_available)}}>{parseAndFormat(allocationDetails.biofuel_conventional_gasoline_available, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_conventional_diesel_available)}}>Conventional biofuel in diesel</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.biofuel_conventional_diesel_available)}}>{parseAndFormat(allocationDetails.biofuel_conventional_diesel_available, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
                <TableHead>
                  <TableRow>
                    <TableCell>Total mandate surplus AVAILABLE</TableCell>
                    <TableCell>{parseAndFormat(allocationDetails.mandate_surplus_available, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
              </Table>
              <Table className={`${classes.table} ${classes.topSpacing}`}>
                <TableHead className="MuiTableCell-head">
                  <TableRow>
                    <TableCell style={{ width: "40%", backgroundColor: colorDetailsVolume }}>Volume check</TableCell>
                    <TableCell style={{ width: "40%", backgroundColor: colorDetailsVolume }}>{allocationDetails.volume_check_status}</TableCell>
                    <TableCell style={{ width: "20%", backgroundColor: colorDetailsVolume }}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="MuiTableBody-root">
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.joint_fulf_in)}}>Joint fulfillment IN</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.joint_fulf_in)}}>{parseAndFormat(allocationDetails.joint_fulf_in, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.joint_fulf_out)}}>Joint fulfillment OUT</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.joint_fulf_out)}}>{parseAndFormat(allocationDetails.joint_fulf_out, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{color: getCellColor(allocationDetails.supplied_biofuel)}}>Supplied biofuel</TableCell>
                    <TableCell style={{color: getCellColor(allocationDetails.supplied_biofuel)}}>{parseAndFormat(allocationDetails.supplied_biofuel, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
                <TableHead>
                  <TableRow>
                    <TableCell>Total volumes</TableCell>
                    <TableCell>{parseAndFormat(allocationDetails.total_volume, 2)}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          <ExpansionPanel expanded={expanded.includes("surplus")} onChange={handleAccordionChange("surplus")}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h5" className={classes.cardTitle}>
                Surplus overview
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Table className={classes.table}>
                <TableHead className="MuiTableCell-head">
                  <TableRow>
                    <TableCell>LOCKED surplus</TableCell>
                    <TableCell></TableCell>
                    <TableCell>Surplus volume</TableCell>
                    <TableCell>AVAILABLE surplus</TableCell>
                    <TableCell>Surplus volume</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="MuiTableBody-root">
                  <TableRow>
                    <TableCell>Customer requirement</TableCell>
                    <TableCell>Advanced biofuel in gasoline</TableCell>
                    <TableCell>{parseAndFormat(surplusOverview.cust_req_bio_adv_gasoline_locked, 2)}</TableCell>
                    <TableCell>Advanced biofuel in gasoline</TableCell>
                    <TableCell>{parseAndFormat(surplusOverview.cust_req_bio_adv_gasoline_available, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Customer requirement</TableCell>
                    <TableCell>Advanced biofuel in diesel</TableCell>
                    <TableCell>{parseAndFormat(surplusOverview.cust_req_bio_adv_diesel_locked, 2)}</TableCell>
                    <TableCell>Advanced biofuel in diesel</TableCell>
                    <TableCell>{parseAndFormat(surplusOverview.cust_req_bio_adv_diesel_available, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Customer requirement</TableCell>
                    <TableCell>Conventional biofuel in gasoline</TableCell>
                    <TableCell>{parseAndFormat(surplusOverview.cust_req_bio_conventional_gasoline_locked, 2)}</TableCell>
                    <TableCell>Conventional biofuel in gasoline</TableCell>
                    <TableCell>{parseAndFormat(surplusOverview.cust_req_bio_conventional_gasoline_available, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Customer requirement</TableCell>
                    <TableCell>Conventional biofuel in diesel</TableCell>
                    <TableCell>{parseAndFormat(surplusOverview.cust_req_bio_conventional_diesel_locked, 2)}</TableCell>
                    <TableCell>Conventional biofuel in diesel</TableCell>
                    <TableCell>{parseAndFormat(surplusOverview.cust_req_bio_conventional_diesel_available, 2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Joint fulfillment OUT</TableCell>
                    <TableCell>Advanced biofuel</TableCell>
                    <TableCell>{parseAndFormat(surplusOverview.out_joint_biofuel_adv_locked, 2)}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Joint fulfillment OUT</TableCell>
                    <TableCell>Conventional biofuel</TableCell>
                    <TableCell>{parseAndFormat(surplusOverview.out_joint_biofuel_conventional_locked, 2)}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>
      )}
      <ModalInfo
        text={errorMessage}
        open={showErrorModal}
        onClose={closeErrorModal}
      />
      <ModalConfirmDelivery
        open={showConfirmDeliveryModal}
        onClose={closeConfirmDeliveryModal}
        onConfirm={() => {
          closeConfirmDeliveryModal();
          handleConfirmationStatus();
        }}
      />
    </div>
  );
};

export default ReportsView;
